var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlacedLocationMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 35
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h25v35H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0C19.404 0 25 5.596 25 12.5c0 2.031-.443 3.927-1.314 5.902-.432.981-1.843 3.332-3.338 5.779l-.675 1.103c-1.424 2.325-2.803 4.565-3.369 5.628a57.008 57.008 0 0 0-1.094 2.167c-1.226 2.561-4.194 2.562-5.42 0a56.918 56.918 0 0 0-1.094-2.167c-1.25-2.35-6.473-10.448-7.381-12.507C.444 16.43 0 14.532 0 12.5 0 5.596 5.596 0 12.5 0zm0 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
  className: "selection-outline"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.5 1.5c6.075 0 11 4.925 11 11 0 1.81-.396 3.503-1.187 5.298-.85 1.928-6.031 9.962-7.333 12.41-.39.731-.763 1.47-1.123 2.224-.682 1.424-2.032 1.424-2.714 0a58.418 58.418 0 0 0-1.123-2.225C8.718 27.76 3.537 19.727 2.687 17.8c-.79-1.795-1.187-3.489-1.187-5.3 0-6.075 4.925-11 11-11zm0 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12.5 2.5c5.523 0 10 4.477 10 10 0 6.13-5 10-9.545 19.5-.32.667-.59.667-.91 0C7.5 22.5 2.5 18.63 2.5 12.5c0-5.523 4.477-10 10-10zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.5 3.5a9 9 0 0 0-9 9c0 1.517.333 2.94 1.018 4.493.772 1.752 5.896 9.697 7.268 12.275.134.252.266.505.397.76l.317.627.317-.628.397-.759c1.371-2.577 6.497-10.524 7.27-12.277.683-1.552 1.016-2.975 1.016-4.491a9 9 0 0 0-9-9zm0 3a6 6 0 1 1 0 12 6 6 0 0 1 0-12z"
})))));
export default SvgPlacedLocationMarker;